import './App.css';
// import './sj_slider.css';
import earth from "../earth/1.0.0/earth";
import Logo from "./Logo";
import {useEffect, useState} from "react";
import CanvasList from "./CanvasList";
import VariableControl from "./VariableControl";
import PeriodControl from "./PeriodControl";
import ColorScaleControl from "./ColorScaleControl";
import ConfigurationControl from "./ConfigurationControl";
import CrossSectionModal from "./CrossSectionModal";
import µ from "../earth/1.0.0/micro";
import _ from "lodash";

function App() {
    const [earthController, setEarthController] = useState({});
    const [menuDisplayToggle, setMenuDisplayToggle] = useState(false);
    const [showPopupCsOverlay, setShowPopupCsOverlay] = useState(false);
    const [rightMenuToggle, setRightMenuToggle] = useState('none');
    const [mouseMode, setMouseMode] = useState("basic");
    const [climateData, setClimateData] = useState(null);
    const [projectionType, setProjectionType] = useState("orthographic");
    const [clearMouseModeAction, setClearMouseModeAction] = useState(true);
    const [levelValue, setLevelValue] = useState(0);
    const [overlayType, setOverlayType] = useState("wind");
    const [isMobile, setIsMobile] = useState(false);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    // resize 이벤트 핸들러..
    // 1000ms = 1sec
    const handleResize = _.debounce(() => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }, 1000);

    //리사이즈 이벤트를 위한 사이드이펙트
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => { // cleanup
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        // 디바이스 종류 설정
        if (µ.isMobile()) {
            console.log('MOBILE');
            setIsMobile(true);
            (async () => {
                await import('./commonMobile.css');
            })();
        } else {
            console.log('PC');
            setIsMobile(false);
            (async () => {
                await import('./common.css');
            })();
        }

        earth().then((controller) => {
            setEarthController(controller);
        })
    }, []);

    return (
        <>
            <div className={rightMenuToggle !== 'none' ? 'wrap on' : 'wrap'}>
                <Logo isMobile={isMobile}></Logo>
                <a href="javascript:;" className="btn_menu01" onClick={() => setMenuDisplayToggle(!menuDisplayToggle)}><span className="blind">크게보기</span></a>
                <CanvasList earthController={earthController} setClimateData={setClimateData} clearMouseModeAction={clearMouseModeAction} setClearMouseModeAction={setClearMouseModeAction}></CanvasList>
                <VariableControl isMobile={isMobile} earthController={earthController} menuDisplayToggle={menuDisplayToggle}  rightMenuToggle={rightMenuToggle}
                                  setRightMenuToggle={setRightMenuToggle} setClearMouseModeAction={setClearMouseModeAction} levelValue={levelValue} setLevelValue={setLevelValue} overlayType={overlayType} setOverlayType={setOverlayType} setMouseMode={setMouseMode}></VariableControl>
                <PeriodControl isMobile={isMobile} earthController={earthController} menuDisplayToggle={menuDisplayToggle} climateData={climateData} mouseMode={mouseMode} setClearMouseModeAction={setClearMouseModeAction} levelValue={levelValue}
                                overlayType={overlayType} rightMenuToggle={rightMenuToggle} windowSize={windowSize}></PeriodControl>
            </div>
            {isMobile ? '' : <ColorScaleControl earthController={earthController} menuDisplayToggle={menuDisplayToggle} rightMenuToggle={rightMenuToggle} setRightMenuToggle={setRightMenuToggle} overlayType={overlayType}></ColorScaleControl>}
            <ConfigurationControl isMobile={isMobile} earthController={earthController} menuDisplayToggle={menuDisplayToggle} rightMenuToggle={rightMenuToggle} setRightMenuToggle={setRightMenuToggle} mouseMode={mouseMode} setMouseMode={setMouseMode} projectionType={projectionType} setProjectionType={setProjectionType} setClimateData={setClimateData} clearMouseModeAction={clearMouseModeAction} setClearMouseModeAction={setClearMouseModeAction} overlayType={overlayType}></ConfigurationControl>
            <CrossSectionModal isMobile={isMobile} earthController={earthController} mouseMode={mouseMode} climateData={climateData} projectionType={projectionType} showPopupCsOverlay={showPopupCsOverlay} setShowPopupCsOverlay={setShowPopupCsOverlay} setClearMouseModeAction={setClearMouseModeAction}></CrossSectionModal>
        </>
    );
}

export default App;
